import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs'
import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n)
// 默认是中文
// const lang = sessionStorage.getItem('language') === 'en' ? 'en' : 'cn'
// 默认是英文
const lang = sessionStorage.getItem('language') === 'cn' ? 'cn' : 'en'
sessionStorage.setItem('language', lang)
const i18n = new VueI18n({
  locale: lang,
  messages
})
ElementLocale.i18n((key, value) => i18n.t(key, value)) // 重点：为了实现element插件的多语言切换

export default i18n
